import apiClient from '@/lib/api';
import type { AddressFetchResult, HereItem } from '@easyflow/ui-frontend/components/AddressAutocomplete';

/**
 * Task #2895 / #2963 — fetcher master per l'autocomplete HERE. Usa la rotta
 * master dedicata (`/master/integrations/geocode/autocomplete`) protetta da
 * `requireMasterTenantAdmin`. La rotta risponde sempre 200 con `{items,
 * available}`; `available:false` (HERE non configurato) fa degradare il campo
 * a input manuale con hint "non configurato". Fonte unica condivisa da tutti i
 * form master con campo indirizzo.
 */
export async function masterAddressFetch(q: string): Promise<AddressFetchResult> {
  try {
    const res = await apiClient.get<{ items?: HereItem[]; available?: boolean }>(
      `/master/integrations/geocode/autocomplete?q=${encodeURIComponent(q)}&lang=it&countryCode=ITA`
    );
    if (res.data?.available === false) return { status: 'not_configured' };
    return { status: 'ok', items: res.data?.items ?? [] };
  } catch (err: unknown) {
    const msg = err instanceof Error ? err.message : '';
    if (msg.includes('404') || msg.includes('501')) return { status: 'not_configured' };
    if (msg.includes('502') || msg.includes('503')) return { status: 'unavailable' };
    return { status: 'error' };
  }
}
